import { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { EMPTY_OBJECT, AppContext, UserContext } from 'commons-ui';

import useService from '../../coupon/utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { location, history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { toggleIsDisabledField } = useService();
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/edit',
					state: {
						rowData
					}
				});
			};

		case 'edit_bulk':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/bulk/edit',
					state: {
						rowData
					}
				});
			};

		case 'clone':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/clone',
					state: {
						rowData
					}
				});
			};
		case 'clone_bulk':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/bulk/clone',
					state: {
						rowData
					}
				});
			};

		case 'conversions':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/payoutDetails',
					state: {
						rowData
					}
				});
			};

		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/create'
				});
			};

		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/list'
				});
			};

		case 'create_bulk':
			return () => {
				const data = _isEmpty(rowData) ? location.state.rowData : rowData;
				history.push({
					pathname: '/dashboard/partnerCoupon/bulk/create',
					state: {
						rowData: data
					}
				});
			};

		case 'show_bulk':
			return () => {
				history.push({
					pathname: '/dashboard/partnerCoupon/bulk/show',
					state: {
						rowData
					}
				});
			};

		case 'download_csv':
			return () => {
				window.open(rowData.csvLink, '_blank');
			};

		case 'deploy': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};

			const { isDisabled } = rowData;
			return () => {
				setConfirmationDialog({
					show: true,
					header: isDisabled ? 'Deploy on app?' : 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}

		case 'remove': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};

			const { isDisabled } = rowData;
			return () => {
				setConfirmationDialog({
					show: true,
					header: isDisabled ? 'Deploy on app?' : 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
